export default __webpack_public_path__ + "static/media/icon_aquamarine.88b92ba3.png";